import posthog from "posthog-js";

export function identify(userId: string, properties?: Record<string, unknown>) {
  try {
    if (typeof posthog?.identify === "function") {
      posthog.identify(userId, properties);
    }
  } catch (error) {
    console.debug("PostHog identify skipped:", error);
  }
}

export function capture(eventName: string, properties?: Record<string, unknown>) {
  try {
    if (typeof posthog?.capture === "function") {
      posthog.capture(eventName, properties);
    }
  } catch (error) {
    console.debug("PostHog capture skipped:", error);
  }
}

export function registerGlobals(properties: Record<string, unknown>) {
  try {
    if (typeof posthog?.register === "function") {
      posthog.register(properties);
    }
  } catch (error) {
    console.debug("PostHog register skipped:", error);
  }
}

export function getSessionId(): string | undefined {
  try {
    if (typeof posthog?.get_session_id === "function") {
      return posthog.get_session_id();
    }
  } catch {
    return undefined;
  }
}
